import { render } from "./MenuChildrenComponent.vue?vue&type=template&id=492b20e8"
import script from "./MenuChildrenComponent.vue?vue&type=script&lang=js"
export * from "./MenuChildrenComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/components/MenuChildrenComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "492b20e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('492b20e8', __exports__)) {
    api.reload('492b20e8', __exports__)
  }
  
  module.hot.accept("./MenuChildrenComponent.vue?vue&type=template&id=492b20e8", () => {
    api.rerender('492b20e8', render)
  })

}


export default __exports__